<template>
  <div class="matrix_layoutMain container" :class="getClassNameContainer">
    <div class="row">
      <div class="col-md-12">
        <appQuantitySelectionContainer></appQuantitySelectionContainer>
        <appCustomerNotesTable v-if="getShowCustomerNotes">
          <appCustomerNotes></appCustomerNotes>
        </appCustomerNotesTable>
        <appAddToCartButton></appAddToCartButton>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from "pinia";
import { useWebproductStore } from "../../stores/modules/webproduct";

export default {
  computed: {
    ...mapState(useWebproductStore, ["getShowCustomerNotes"])
  }
};
</script>
